import { useEffect } from "react";
import { SITE_URL } from "@/lib/api";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path, jsonLd, image }) {
  const ldKey = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
      setMeta("name", "twitter:card", "summary_large_image");
    }
    if (path) {
      setMeta("property", "og:url", `${SITE_URL}${path}`);
      setMeta("name", "twitter:title", title);
      setMeta("name", "twitter:description", description);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = `${SITE_URL}${path}`;
    }
    let script;
    if (ldKey) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.textContent = ldKey;
      document.head.appendChild(script);
    }
    return () => {
      document.getElementById("page-jsonld")?.remove();
    };
  }, [title, description, path, ldKey]);
}
